var render, staticRenderFns
import script from "./responsive-craft-visual.vue?vue&type=script&lang=coffee&"
export * from "./responsive-craft-visual.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports